module.exports = __webpack_public_path__ + "media/images/nuvem-31b4d042cd98efe5ed1bf6b6eaa61bab.svg";